module.exports = __webpack_public_path__ + "static/dragon-8e7f21f992b824875e9cffe3b147b00f.svg";